import { api } from './Api'

interface LoginResponse {
  token: string
  user: {
    id: string
    email: string
    name: string
  }
}

interface LoginRequest {
  email: string
  password: string
  //device_name: string
}

interface ForgotPasswordRequest {
  email: string
}

export const authApi = {
  login: (data: LoginRequest) => 
    api.post<LoginResponse>('/login', data).catch(error => {
      return error;
    }),

  forgotPassword: (data: ForgotPasswordRequest) =>
    api.post<void>('/forgot-password', data),

  logout: () => {
    api.clearToken()
    return api.post<void>('/logout')
  }
}